import React, { createContext, useState, useEffect, useContext } from "react";
import axios from "../api/axiosInstance";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [accessTokenState, setAccessToken] = useState(null);
  const [, setRefreshToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const localAccessToken = localStorage.getItem("accessToken");
    const localRefreshToken = localStorage.getItem("refreshToken");
    if (localAccessToken) {
      setAccessToken(localAccessToken);
      setRefreshToken(localRefreshToken);
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post("/user/login", { email, password });

    const { accessToken, refreshToken } = data;
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);

    setAccessToken(accessToken);
    setRefreshToken(refreshToken);
  };

  const register = async ({ email, password, registerToken }) => {
    const { data } = await axios.post("/user/register", {
      email,
      password,
      registerToken,
    });

    const { accessToken, refreshToken } = data;
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.removeItem("invitationToken");
    setAccessToken(accessToken);
    setRefreshToken(refreshToken);
  };

  const logout = async () => {
    await axios.post("/user/login");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    setAccessToken(null);
  };

  return (
    <AuthContext.Provider
      value={{
        login,
        logout,
        register,
        token: accessTokenState,
        isAuthenticated: !!accessTokenState,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
